import ProductList from '@components/frontStore/catalog/product/list/List';
import PropTypes from 'prop-types';
import React from 'react';
export default function CollectionProducts(_ref) {
  var _collection$products;
  var {
    collection
  } = _ref;
  if (!collection) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-width"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mt-12 mb-12 text-center uppercase h5 tracking-widest"
  }, collection === null || collection === void 0 ? void 0 : collection.name), /*#__PURE__*/React.createElement(ProductList, {
    products: collection === null || collection === void 0 || (_collection$products = collection.products) === null || _collection$products === void 0 ? void 0 : _collection$products.items,
    countPerRow: 4
  })));
}
CollectionProducts.propTypes = {
  collection: PropTypes.shape({
    collectionId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    products: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        productId: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.shape({
          regular: PropTypes.shape({
            value: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired
          }).isRequired,
          special: PropTypes.shape({
            value: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired
          }).isRequired
        }).isRequired,
        image: PropTypes.shape({
          alt: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired
        }).isRequired,
        url: PropTypes.string.isRequired
      })).isRequired
    }).isRequired
  }).isRequired,
  collectionProductsWidget: PropTypes.shape({
    count: PropTypes.number
  }).isRequired
};
export var query = "\n  query Query($collection: String, $count: ID) {\n    collection (code: $collection) {\n      collectionId\n      name\n      products (filters: [{key: \"limit\", operation: eq, value: $count}]) {\n        items {\n          ...Product\n        }\n      }\n    }\n  }\n";
export var fragments = "\n  fragment Product on Product {\n    productId\n    isSpicy\n    name\n    nameAr\n    price {\n      regular {\n        value\n        text\n      }\n      special {\n        value\n        text\n      }\n    }\n    image {\n      alt\n      url: listing\n    }\n    category {\n      name\n      nameAr\n    }\n    url\n  }\n";
export var variables = "{\n  collection: getWidgetSetting(\"collection\"),\n  count: getWidgetSetting(\"count\")\n}";